var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { addTourToCart, fetchAccommodations, fetchExternalFlight, fetchHotelRecommendationsNew, fetchTourDetails, fetchTourDetailsFromCart, fetchTourVariant } from 'api-ito/ToursApi';
import _, { range } from 'lodash';
import moment from 'moment';
import { createHook, createSelector, createStore } from 'react-sweet-state';
import { fetchExcursionPrice } from '../../../include/api-ito/ExcursionsApi';
import { api } from '../../../include/network/network';
import { appUrl, removeEmptyFields } from '../../../include/utils';
import { getExtraKey, mapExtrasToJsonCompatibility } from './utils';
export const CreateTourDescriptionStore = (actions) => {
    return createStore({
        initialState: {
            loaded: false,
            loading: true,
            flightsLoading: false,
            loadingHotelRecommendations: false,
            loadingAccommodationVariants: false,
            loadingTourVariant: false,
            loadAccommodationVariantsErrors: [],
            loadDescriptionErrors: [],
            loadHotelRecommendationsErrors: [],
            loadExternalFlightErrors: [],
            hasAccommodation: false,
            setBookingParamsErrors: [],
            tourDescription: undefined,
            tourVariant: undefined,
            tourEvents: [],
            tourServices: [],
            accommodationVariants: undefined,
            currentAccommodationVariants: [],
            hotelRecommendations: undefined,
            viewConfig: {
                hidePrices: false,
            },
            frameId: undefined,
            tempFrameId: undefined,
            hash: undefined,
            price: undefined,
            totalVariantPrice: 0,
            totalVariantPriceOriginal: 0,
            externalFlight: undefined,
            externalFlightId: undefined,
            externalFlightProviderId: undefined,
            externalFlights: {},
            flightConfiguration: {
                seatsWarningUpperBoundary: 0,
                initialResultLimit: 6,
                resultLimit: 10,
            },
            flightSearchMetadata: {
                isSearchPerformed: false,
                flightsRemain: 0,
                allAirlines: [],
                maxStopDurationBounds: { from: 0, to: 0 },
                forwardArrivalRangeBounds: { from: moment(new Date(1, 1, 1)), to: moment(new Date(9999, 12, 31, 23, 59, 59)) },
                forwardDepartureRangeBounds: { from: moment(new Date(1, 1, 1)), to: moment(new Date(9999, 12, 31, 23, 59, 59)) },
                returnArrivalRangeBounds: { from: moment(new Date(1, 1, 1)), to: moment(new Date(9999, 12, 31, 23, 59, 59)) },
                returnDepartureRangeBounds: { from: moment(new Date(1, 1, 1)), to: moment(new Date(9999, 12, 31, 23, 59, 59)) },
                stops: [0, 1, 2, 3],
                airlineLaxFiltering: true,
                airlineIds: [],
                baggage: ['withbaggage', 'withoutbaggage'],
                maxStopDuration: 0,
                forwardArrivalRange: { from: moment(new Date(1, 1, 1)), to: moment(new Date(9999, 12, 31, 23, 59, 59)) },
                forwardDepartureRange: { from: moment(new Date(1, 1, 1)), to: moment(new Date(9999, 12, 31, 23, 59, 59)) },
                returnArrivalRange: { from: moment(new Date(1, 1, 1)), to: moment(new Date(9999, 12, 31, 23, 59, 59)) },
                returnDepartureRange: { from: moment(new Date(1, 1, 1)), to: moment(new Date(9999, 12, 31, 23, 59, 59)) },
            },
            prevExtras: {},
            extras: {},
            search: undefined
        },
        actions: actions,
        name: 'TourDescriptionStore'
    });
};
export const CreateTourFlightSearchMetadataHook = (store) => {
    return createHook(store, {
        selector: createSelector(state => ({
            flightSearchMetadata: state.flightSearchMetadata,
        }), (state) => {
            return Object.assign({}, state.flightSearchMetadata);
        })
    });
};
export const CreateTourDescriptionHook = (store) => {
    return createHook(store, {
        selector: createSelector(state => ({
            desc: state.tourDescription,
            svcs: state.tourServices,
            evts: state.tourEvents,
            hotels: state.currentAccommodationVariants.map(v => ({ hotelDescription: v.hotelDescription, externalHotelPrice: v.externalHotelPrice })),
            hasAccmmd: state.hasAccommodation,
            hash: state.hash,
            price: state.price,
            externalFlight: state.externalFlight,
            externalFlightId: state.externalFlightId,
            externalFlightProviderId: state.externalFlightProviderId,
            externalFlights: state.externalFlights,
            flightsLoading: state.flightsLoading,
        }), (state) => {
            if (!state.desc)
                throw new Error('Tour description is not loaded');
            const excursions = findServiceOfType(state.svcs, 'excursion');
            const transfers = findServiceOfType(state.svcs, 'transfer');
            const extras = findServiceOfType(state.svcs, 'extra');
            const flights = findServiceOfType(state.svcs, 'flight');
            const hotels = findServiceOfType(state.svcs, 'hotel');
            return {
                tourDescription: state.desc,
                tourEvents: state.evts,
                excursionServices: excursions,
                transferServices: transfers,
                extraServices: extras,
                flightServices: flights,
                hotelServices: hotels,
                hotelDescriptions: state.hotels,
                hasAccommodation: state.hasAccmmd,
                hash: state.hash,
                price: state.price,
                externalFlight: state.externalFlight,
                externalFlightId: state.externalFlightId,
                externalFlightProviderId: state.externalFlightProviderId,
                externalFlights: state.externalFlights,
                flightsLoading: state.flightsLoading,
            };
        })
    });
};
export const CreateExtrasHook = (store) => {
    return createHook(store, {
        selector: state => ({
            price: state.price,
            extras: state.extras,
            prevExtras: state.prevExtras,
            hash: state.hash
        }),
    });
};
export const CreateViewConfigHook = (store) => {
    return createHook(store, {
        selector: state => state.viewConfig
    });
};
export const CreateTourVariantHook = (store) => {
    return createHook(store, {
        selector: state => ({
            initialized: !!state.tourVariant,
            tourVariant: state.tourVariant,
            currentAccommodationVariants: state.currentAccommodationVariants,
            loading: state.loadingTourVariant,
            errors: state.setBookingParamsErrors,
            totalVariantPrice: state.totalVariantPrice,
        })
    });
};
export const CreateTourAccmmdVariantsHook = (store) => {
    return createHook(store, {
        selector: state => ({
            initialized: !!state.accommodationVariants,
            loading: state.loadingAccommodationVariants,
            accmmdVariants: state.accommodationVariants,
            errors: state.loadAccommodationVariantsErrors,
        })
    });
};
export const CreateHotelRecommendationsHook = (store) => {
    return createHook(store, {
        selector: state => ({
            initialized: !!state.hotelRecommendations,
            loading: state.loadingHotelRecommendations,
            recommendations: state.hotelRecommendations,
            errors: state.loadHotelRecommendationsErrors,
        })
    });
};
const reloadExtras = (extras) => ({ setState, getState }) => {
    setState({ extras: Object.assign({}, extras) });
};
const updateExtra = (id, mens) => ({ setState, getState }) => {
    const { extras } = getState();
    if (!(mens === null || mens === void 0 ? void 0 : mens.length)) {
        let newExtras = removeEmptyFields(Object.assign(Object.assign({}, extras), { [id]: mens }));
        setState({ prevExtras: Object.assign({}, extras), extras: Object.assign({}, newExtras) });
    }
    else
        setState({ prevExtras: Object.assign({}, extras), extras: Object.assign(Object.assign({}, extras), { [id]: mens }) });
};
const setFlightFilter = (filter) => ({ setState, getState }) => {
    const { flightSearchMetadata } = getState();
    if (!flightSearchMetadata)
        return;
    setState({ flightSearchMetadata: Object.assign(Object.assign({}, flightSearchMetadata), filter) });
};
const resetStopsFilter = () => ({ setState, getState }) => {
    const { flightSearchMetadata } = getState();
    if (!flightSearchMetadata)
        return;
    setState({ flightSearchMetadata: Object.assign(Object.assign({}, flightSearchMetadata), { stops: [0, 1, 2, 3] }) });
};
const resetAirlinesFilter = () => ({ setState, getState }) => {
    const { flightSearchMetadata } = getState();
    if (!flightSearchMetadata)
        return;
    setState({
        flightSearchMetadata: Object.assign(Object.assign({}, flightSearchMetadata), { airlineLaxFiltering: true, airlineIds: flightSearchMetadata.allAirlines.map(a => a.id) })
    });
};
const resetBaggageFilter = () => ({ setState, getState }) => {
    const { flightSearchMetadata } = getState();
    if (!flightSearchMetadata)
        return;
    setState({ flightSearchMetadata: Object.assign(Object.assign({}, flightSearchMetadata), { baggage: ['withbaggage', 'withoutbaggage'] }) });
};
const resetStopDurationFilter = () => ({ setState, getState }) => {
    const { flightSearchMetadata } = getState();
    if (!flightSearchMetadata)
        return;
    setState({
        flightSearchMetadata: Object.assign(Object.assign({}, flightSearchMetadata), { maxStopDuration: flightSearchMetadata.maxStopDurationBounds.to })
    });
};
const resetTimeRangesFilter = () => ({ setState, getState }) => {
    const { flightSearchMetadata } = getState();
    if (!flightSearchMetadata)
        return;
    setState({
        flightSearchMetadata: Object.assign(Object.assign({}, flightSearchMetadata), { forwardArrivalRange: Object.assign({}, flightSearchMetadata.forwardArrivalRangeBounds), forwardDepartureRange: Object.assign({}, flightSearchMetadata.forwardDepartureRangeBounds), returnArrivalRange: Object.assign({}, flightSearchMetadata.returnArrivalRangeBounds), returnDepartureRange: Object.assign({}, flightSearchMetadata.returnDepartureRangeBounds) })
    });
};
const resetAllSecondaryFilters = () => ({ dispatch }) => {
    dispatch(resetStopsFilter());
    dispatch(resetAirlinesFilter());
    dispatch(resetBaggageFilter());
    dispatch(resetStopDurationFilter());
    dispatch(resetTimeRangesFilter());
};
export const getTourCostInternal = (state) => {
    let cost = {
        netto: 0,
        brutto: 0,
        discount: 0,
    };
    if (!state.price || !state.tourVariant)
        return cost;
    const { price, tourVariant, extras, tourServices } = state;
    for (let service of price.allServices.filter(s => { var _a; return !state.externalFlight || !((_a = price.defaultAirServices) === null || _a === void 0 ? void 0 : _a.find(d => d == s.compositeId)); })) {
        cost.netto += service.costEntityWithPromo.netto;
        cost.brutto += service.costEntityWithPromo.brutto;
        cost.discount += service.costEntityWithPromo.discount;
    }
    if (state.externalFlight) {
        cost.netto += state.externalFlight.flightCostEntityWithPromo.netto;
        cost.brutto += state.externalFlight.flightCostEntityWithPromo.brutto;
        cost.discount += state.externalFlight.flightCostEntityWithPromo.discount;
    }
    const allMens = [...range(0, tourVariant.adultCount).map(x => 18), ...tourVariant.childAges];
    for (let service of price.extras) { //.filter(s => !!extras[getExtraKey(s)]?.length)) {
        const extraMens = extras[getExtraKey(service)];
        if (!(extraMens === null || extraMens === void 0 ? void 0 : extraMens.length))
            continue;
        const mensInService = allMens.map((value, index) => ({ value, index })).filter(x => x.value >= service.ageFrom && x.value < service.ageTo && extraMens.findIndex(m => m == x.index) >= 0).length;
        cost.netto += service.costEntityWithPromo.netto * (service.isGroupCost ? 1 : mensInService);
        cost.brutto += service.costEntityWithPromo.brutto * (service.isGroupCost ? 1 : mensInService);
        cost.discount += service.costEntityWithPromo.discount * (service.isGroupCost ? 1 : mensInService);
    }
    return cost;
};
export const getTourCost = () => {
    return ({ getState }) => {
        const cost = getTourCostInternal(getState());
        return {
            brutto: cost.brutto,
            netto: cost.netto,
            discount: cost.discount,
            total: cost.brutto + cost.discount,
            roundBrutto: Math.ceil(cost.brutto),
            roundTotal: Math.ceil(cost.brutto + cost.discount),
            roundDiscount: Math.ceil(cost.brutto + cost.discount) - Math.ceil(cost.brutto),
        };
    };
};
export const loadDescription = (params) => {
    return ({ setState }) => __awaiter(void 0, void 0, void 0, function* () {
        setState({ frameId: params.frameId, tempFrameId: params.tempFrameId });
        if ('hash' in params)
            setState({ hash: params.hash, search: params.search });
        //setState({ loading: true, frameId: params.frameId, tempFrameId: params.tempFrameId });
        const result = 'fromCart' in params ? yield fetchTourDetailsFromCart() : yield fetchTourDetails(params);
        //setState({ loading: false });
        if (!('errors' in result)) {
            setState({ price: result.priceItem });
            const [services, hotelServices] = result.tourServices.reduce(([services, hotelServices], x) => {
                if (x.type === 'hotel') {
                    hotelServices.push(x);
                }
                services.push(x);
                return [services, hotelServices];
            }, [[], []]);
            if (hotelServices.length == 0) {
                setState({ currentAccommodationVariants: [], hasAccommodation: false, });
            }
            else {
                setState({
                    currentAccommodationVariants: hotelServices.map((hotel) => ({
                        accommodation: hotel.accommodation,
                        hotelDescription: hotel.hotelDescription,
                        externalHotelPrice: hotel.externalHotelPrice,
                    })),
                    hasAccommodation: true,
                });
            }
            setState({
                tourDescription: result.tourDescription,
                tourEvents: result.tourEvents,
                tourServices: services,
                tourVariant: result.tourVariant,
                totalVariantPrice: result.totalVariantPrice,
                totalVariantPriceOriginal: result.totalVariantPriceOriginal,
                loadDescriptionErrors: [],
                //extras: result.extras ?? {},
                loaded: true,
            });
            return [];
        }
        else {
            setState({ loadDescriptionErrors: result.errors });
            return result.errors;
        }
    });
};
export const loadExcursionPrices = (excursions, hash) => ({ setState, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    const { tourServices, tourVariant, tourDescription, currentAccommodationVariants } = getState();
    if (!tourVariant || !tourVariant.checkInDate || !tourDescription)
        return [];
    //setState({ loading: true });
    for (const excursion of tourServices.filter(s => s.type == "excursion").map(s => s)) {
        if (!excursions.find(s => s.id == excursion.id) || !excursion.beginDate || new Date(excursion.beginDate).toString() == new Date("0001-01-01T00:00:00").toString())
            continue;
        var result = yield fetchExcursionPrice(excursion.id, excursion.beginDate, tourVariant.adultCount, tourVariant.childAges.map((x) => ({ age: x, withPlace: true })), tourVariant.tourId);
        if (!('errors' in result)) {
            setState({
                tourServices: [...tourServices].map(service => {
                    var _a, _b;
                    if (service.type == "excursion" && service.id == excursion.id) {
                        const exc = service;
                        exc.prices = result;
                        //const vehicleTypeId = excursions.find(e => e.id == exc.id)?.vehicleTypeId;
                        exc.currentVehicleTypeId = (_a = excursions.find(s => s.id == exc.id)) === null || _a === void 0 ? void 0 : _a.vehicleTypeId;
                        if (((_b = exc.prices) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                            if (!exc.prices.find((e) => exc.currentVehicleTypeId == e.vehicleTypeId) || exc.currentVehicleTypeId == undefined) {
                                exc.currentVehicleTypeId = exc.prices[0].vehicleTypeId;
                                exc.excursionPrice = exc.prices[0];
                            }
                            else
                                exc.excursionPrice = exc.prices.find((x) => x.vehicleTypeId == exc.currentVehicleTypeId);
                        }
                    }
                    return service;
                })
            });
        }
        else {
            setState({ loadDescriptionErrors: result.errors });
            return result.errors;
        }
    }
    //setState({ loading: false });
    return [];
});
const setBookingParams = ({ date, duration, tourists, handlers }) => {
    return ({ setState, getState, dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const { tourDescription: desc, tourVariant, currentAccommodationVariants, hotelRecommendations, hasAccommodation, tourServices, frameId, tempFrameId, hash } = getState();
        const wantDate = moment(date).format('YYYY-MM-DD');
        const writeErrors = (errors) => {
            setState({ setBookingParamsErrors: errors });
            return errors;
        };
        if (!desc || (!tourVariant && !tourists))
            return writeErrors(['Bad invocation']);
        const { adultCount, childAges } = !tourists
            ? { adultCount: tourVariant.adultCount, childAges: tourVariant.childAges }
            : tourists;
        const userParams = { date: wantDate, duration, tourists: { adultCount, childAges } };
        let keepLoading = false;
        setState({ loadingTourVariant: true });
        try {
            const variantResponse = yield fetchTourVariant(desc.id, wantDate, duration, adultCount, childAges, hash);
            if ('errors' in variantResponse)
                return writeErrors(variantResponse.errors);
            setState({ tourVariant: variantResponse });
            //keepLoading = true;
            let newHash = (_a = variantResponse.similarPriceHash) !== null && _a !== void 0 ? _a : variantResponse.bestPriceHash;
            if (newHash) {
                yield dispatch(setPriceItem(newHash));
                if (handlers === null || handlers === void 0 ? void 0 : handlers.onFinished)
                    handlers.onFinished(userParams);
            }
            else if (handlers === null || handlers === void 0 ? void 0 : handlers.onTourUnavailable)
                handlers.onTourUnavailable(variantResponse, userParams);
            return [];
        }
        finally {
            if (!keepLoading)
                setState({ loadingTourVariant: false });
        }
    });
};
const setPriceItem = (hash) => ({ setState }) => __awaiter(void 0, void 0, void 0, function* () {
    setState({ hash });
});
const setExcursionTransport = (excursionId, vehicleTypeId) => ({ setState, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    const { tourServices } = getState();
    setState({
        tourServices: [...tourServices].map(x => {
            var _a;
            if (x.type == 'excursion' && x.id == excursionId) {
                var excursion = x;
                if ((_a = excursion.prices) === null || _a === void 0 ? void 0 : _a.length) {
                    excursion.currentVehicleTypeId = vehicleTypeId;
                    if (!excursion.prices.find(e => excursion.currentVehicleTypeId == e.vehicleTypeId) || excursion.currentVehicleTypeId == undefined) {
                        excursion.currentVehicleTypeId = excursion.prices[0].vehicleTypeId;
                        excursion.excursionPrice = excursion.prices[0];
                    }
                    else
                        excursion.excursionPrice = excursion.prices.find(x => x.vehicleTypeId == excursion.currentVehicleTypeId);
                }
            }
            return x;
        })
    });
});
const loadAccommodationVariants = () => {
    return ({ getState, setState }) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const { tourDescription: desc, tourVariant, currentAccommodationVariants, hash } = getState();
        if (!tourVariant || !desc || !currentAccommodationVariants.length)
            return [];
        let errors = [];
        let variants = [];
        let accmmds = [];
        setState({ loadingAccommodationVariants: false });
        for (let i = 0; i < currentAccommodationVariants.length; i++) {
            const currentAccommodationVariant = currentAccommodationVariants[i];
            const accmmdsResponse = yield fetchAccommodations(desc.id, tourVariant.adultCount, tourVariant.childAges, tourVariant.checkInDate, false, i, hash);
            if ('errors' in accmmdsResponse) {
                errors.push(...accmmdsResponse.errors);
            }
            else {
                accmmds.push((_b = (_a = accmmdsResponse[0]) === null || _a === void 0 ? void 0 : _a.accomodationVariants) !== null && _b !== void 0 ? _b : []);
            }
        }
        setState({ loadingAccommodationVariants: false });
        if (errors.length) {
            setState({ loadAccommodationVariantsErrors: errors });
            return errors;
        }
        setState({
            accommodationVariants: accmmds,
            loadAccommodationVariantsErrors: [],
        });
        return [];
    });
};
const loadHotelRecommendations = (tourVariantId) => {
    return ({ setState, getState }) => __awaiter(void 0, void 0, void 0, function* () {
        const { tourVariant, hash } = getState();
        if (!tourVariant)
            throw new Error('Bad invocation');
        setState({ loadingHotelRecommendations: true });
        try {
            const response = yield fetchHotelRecommendationsNew(tourVariant.id, hash);
            if ('errors' in response) {
                setState({ loadHotelRecommendationsErrors: response.errors, });
                return response.errors;
            }
            setState({
                hotelRecommendations: response,
                loadHotelRecommendationsErrors: [],
            });
            return [];
        }
        finally {
            setState({ loadingHotelRecommendations: false });
        }
    });
};
const loadExternalFlight = (flightId, providerId) => {
    return ({ setState, getState }) => __awaiter(void 0, void 0, void 0, function* () {
        const { tourVariant, hash } = getState();
        if (!tourVariant || !hash)
            throw new Error('Bad invocation');
        if (!flightId || !providerId)
            return [];
        setState({ loadingHotelRecommendations: true });
        try {
            const response = yield fetchExternalFlight(hash, { flightId, providerId });
            if ('errors' in response) {
                setState({ loadExternalFlightErrors: response.errors, });
                return response.errors;
            }
            setState({
                externalFlight: response,
                externalFlightId: response === null || response === void 0 ? void 0 : response.flightId,
                externalFlightProviderId: response === null || response === void 0 ? void 0 : response.providerId,
                loadHotelRecommendationsErrors: [],
            });
            return [];
        }
        finally {
            setState({ loadingHotelRecommendations: false });
        }
    });
};
const setFlight = (flight) => ({ setState }) => __awaiter(void 0, void 0, void 0, function* () {
    setState({ externalFlight: flight, externalFlightId: flight.flightId, externalFlightProviderId: flight.providerId });
});
const setFlightVariants = (flights) => ({ setState }) => __awaiter(void 0, void 0, void 0, function* () {
    setState({ externalFlights: flights });
});
const addFlightVariants = (flights) => ({ setState, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    setState({ externalFlights: Object.assign(Object.assign({}, getState().externalFlights), flights) });
});
const clearFlightVariants = () => ({ setState, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    setState({ externalFlights: {} });
});
const searchExternalFlight = (first, applyAdditionalFilters, clearBefore, disableCache) => ({ getState, setState, dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { flightSearchMetadata, price, tourServices, tourVariant, flightsLoading, hash, externalFlights, flightConfiguration } = getState();
    if (!tourServices.find(v => v.type == 'flight'))
        return [];
    if (!tourVariant || flightsLoading)
        return [];
    setState({ flightsLoading: true });
    try {
        let flights = tourServices.filter(v => v.type == 'flight').map(v => v);
        if (flights.length > 1)
            flights = [flights[0], flights[flights.length - 1]];
        const query = {
            hash: hash,
            disableCache: disableCache || false,
            includeMetadata: first,
            flights: flights.map(f => ({ cityFromId: f.cityFrom.id, cityToId: f.cityTo.id, departureDate: f.beginDate })),
            fareClassId: flights[0].flightClass.id,
            adultPassengers: tourVariant.adultCount,
            childPassengers: tourVariant.childAges.filter(c => c >= 2).length,
            infantPassengers: tourVariant.childAges.filter(c => c < 2).length,
            stops: applyAdditionalFilters && !!flightSearchMetadata ? flightSearchMetadata.stops : [0, 1, 2, 3],
            offset: first || clearBefore ? 0 : Object.keys(externalFlights).length,
            limit: first || clearBefore ? flightConfiguration.initialResultLimit : flightConfiguration.resultLimit,
            airlines: applyAdditionalFilters && flightSearchMetadata ? flightSearchMetadata.airlineIds : undefined,
            airlinesFilterMode: applyAdditionalFilters && flightSearchMetadata ? (flightSearchMetadata.airlineLaxFiltering ? 'lax' : 'strict') : undefined,
            maxStopDuration: applyAdditionalFilters && flightSearchMetadata ? Math.floor(flightSearchMetadata.maxStopDuration / 60) : undefined,
            forwardDepartureNotBeforeTime: applyAdditionalFilters && flightSearchMetadata ? (_a = flightSearchMetadata.forwardDepartureRange.from) === null || _a === void 0 ? void 0 : _a.format('YYYY-MM-DD HH:mm:ss') : undefined,
            forwardDepartureNotAfterTime: applyAdditionalFilters && flightSearchMetadata ? (_b = flightSearchMetadata.forwardDepartureRange.to) === null || _b === void 0 ? void 0 : _b.format('YYYY-MM-DD HH:mm:ss') : undefined,
            forwardArrivalNotBeforeTime: applyAdditionalFilters && flightSearchMetadata ? (_c = flightSearchMetadata.forwardArrivalRange.from) === null || _c === void 0 ? void 0 : _c.format('YYYY-MM-DD HH:mm:ss') : undefined,
            forwardArrivalNotAfterTime: applyAdditionalFilters && flightSearchMetadata ? (_d = flightSearchMetadata.forwardArrivalRange.to) === null || _d === void 0 ? void 0 : _d.format('YYYY-MM-DD HH:mm:ss') : undefined,
            returnDepartureNotBeforeTime: applyAdditionalFilters && flightSearchMetadata ? (_e = flightSearchMetadata.returnDepartureRange.from) === null || _e === void 0 ? void 0 : _e.format('YYYY-MM-DD HH:mm:ss') : undefined,
            returnDepartureNotAfterTime: applyAdditionalFilters && flightSearchMetadata ? (_f = flightSearchMetadata.returnDepartureRange.to) === null || _f === void 0 ? void 0 : _f.format('YYYY-MM-DD HH:mm:ss') : undefined,
            returnArrivalNotBeforeTime: applyAdditionalFilters && flightSearchMetadata ? (_g = flightSearchMetadata.returnArrivalRange.from) === null || _g === void 0 ? void 0 : _g.format('YYYY-MM-DD HH:mm:ss') : undefined,
            returnArrivalNotAfterTime: applyAdditionalFilters && flightSearchMetadata ? (_h = flightSearchMetadata.returnArrivalRange.to) === null || _h === void 0 ? void 0 : _h.format('YYYY-MM-DD HH:mm:ss') : undefined,
            baggage: applyAdditionalFilters && flightSearchMetadata ? flightSearchMetadata.baggage.length == 0 ? 'none' : flightSearchMetadata.baggage.join(',') : 'withbaggage,withoutbaggage',
        };
        var { response, errors } = yield api('post', `/tour/flights/${hash}`, query);
        console.log(response);
        if (errors === null || errors === void 0 ? void 0 : errors.length)
            return errors;
        else if (response) {
            if (!response.data)
                return [response.status];
            else if (response.data) {
                const variants = {};
                response.data.variants.map(f => (Object.assign(Object.assign({}, f), { selectedPrice: f.prices[0] }))).forEach(v => variants[v.groupHash] = v);
                if (first || clearBefore) {
                    yield dispatch(setFlightVariants(variants));
                    if (first && !applyAdditionalFilters && response.data.metadata) {
                        const { metadata: md } = response.data;
                        setState({
                            flightSearchMetadata: {
                                airlineLaxFiltering: true,
                                allAirlines: md.airlines || [],
                                airlineIds: md.airlines.map(a => a.id) || [],
                                stops: [0, 1, 2, 3],
                                baggage: ['withbaggage', 'withoutbaggage'],
                                maxStopDuration: md.maxStopDuration * 60,
                                maxStopDurationBounds: { from: 0, to: md.maxStopDuration * 60 },
                                forwardArrivalRange: { from: moment.utc(md.forwardMinArrivalTime), to: moment.utc(md.forwardMaxArrivalTime) },
                                forwardArrivalRangeBounds: { from: moment.utc(md.forwardMinArrivalTime), to: moment.utc(md.forwardMaxArrivalTime) },
                                forwardDepartureRange: { from: moment.utc(md.forwardMinDepartureTime), to: moment.utc(md.forwardMaxDepartureTime) },
                                forwardDepartureRangeBounds: { from: moment.utc(md.forwardMinDepartureTime), to: moment.utc(md.forwardMaxDepartureTime) },
                                returnArrivalRange: { from: moment.utc(md.returnMinArrivalTime), to: moment.utc(md.returnMaxArrivalTime) },
                                returnArrivalRangeBounds: { from: moment.utc(md.returnMinArrivalTime), to: moment.utc(md.returnMaxArrivalTime) },
                                returnDepartureRange: { from: moment.utc(md.returnMinDepartureTime), to: moment.utc(md.returnMaxDepartureTime) },
                                returnDepartureRangeBounds: { from: moment.utc(md.returnMinDepartureTime), to: moment.utc(md.returnMaxDepartureTime) },
                                flightsRemain: response.data.remaining,
                                isSearchPerformed: true,
                            }
                        });
                    }
                    else {
                        setState({ flightSearchMetadata: Object.assign(Object.assign({}, flightSearchMetadata), { flightsRemain: response.data.remaining }) });
                    }
                }
                else {
                    yield dispatch(addFlightVariants(variants));
                    setState({ flightSearchMetadata: Object.assign(Object.assign({}, flightSearchMetadata), { flightsRemain: response.data.remaining }) });
                }
            }
        }
    }
    finally {
        setState({ flightsLoading: false });
    }
    return [];
});
const TourDescriptionStoreActions = {
    /**
     * Загружает тур для просмотра.
     * @param tourVariantId Идентификатор варианта для просмотра
     * @param accmdVariantId Список выбранных размещений
    */
    loadDescription: loadDescription,
    loadExcursionPrices: loadExcursionPrices,
    setBookingParams: setBookingParams,
    setPriceItem: setPriceItem,
    setExcursionTransport: setExcursionTransport,
    loadAccommodationVariants: loadAccommodationVariants,
    loadHotelRecommendations: loadHotelRecommendations,
    book: (replaceExistingTour) => ({ setState, getState }) => __awaiter(void 0, void 0, void 0, function* () {
        var _j;
        const state = getState();
        if (!state.tourVariant || !state.hash)
            return [];
        const excursionServices = findServiceOfType(state.tourServices, "excursion");
        const excursions = (excursionServices === null || excursionServices === void 0 ? void 0 : excursionServices.length) > 0 ? excursionServices.map(e => `${e.id}=${(e.currentVehicleTypeId == undefined ? '' : e.currentVehicleTypeId)}`).reduce((pr, curr) => `${pr};${curr}`) : "";
        const errors = yield addTourToCart({ tourVariantId: state.tourVariant.id, accmdVariantIds: [], excursions, hash: state.hash, externalFlight: (_j = state.externalFlight) !== null && _j !== void 0 ? _j : (state.externalFlightId && state.externalFlightProviderId ? { flightId: state.externalFlightId, providerId: state.externalFlightProviderId } : undefined), extras: mapExtrasToJsonCompatibility(state.extras), replaceExistingTour });
        if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
            window.location.href = appUrl('/Cart');
        }
        return errors || [];
    }),
    enableLoading: () => ({ setState, getState }) => __awaiter(void 0, void 0, void 0, function* () {
        setState({ loading: true });
    }),
    disableLoading: () => ({ setState, getState }) => __awaiter(void 0, void 0, void 0, function* () {
        setState({ loading: false });
    }),
    enableFlightLoading: () => ({ setState, getState }) => __awaiter(void 0, void 0, void 0, function* () {
        setState({ flightsLoading: true });
    }),
    disableFlightLoading: () => ({ setState, getState }) => __awaiter(void 0, void 0, void 0, function* () {
        setState({ flightsLoading: false });
    }),
    setFlight: setFlight,
    loadExternalFlight: loadExternalFlight,
    setFlightVariants: setFlightVariants,
    addFlightVariants: addFlightVariants,
    clearFlightVariants: clearFlightVariants,
    searchExternalFlight: searchExternalFlight,
    resetStopsFilter: resetStopsFilter,
    resetAirlinesFilter: resetAirlinesFilter,
    resetBaggageFilter: resetBaggageFilter,
    resetStopDurationFilter: resetStopDurationFilter,
    resetTimeRangesFilter: resetTimeRangesFilter,
    resetAllSecondaryFilters: resetAllSecondaryFilters,
    setFlightFilter: setFlightFilter,
    reloadExtras: reloadExtras,
    updateExtra: updateExtra,
    getTourCost: getTourCost,
    //updateExcursion: updateExcursion,
};
export const tourFrameBook = (replaceExistingTour) => ({ setState, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    const state = getState();
    if (!state.tourVariant || !state.hash)
        return [];
    const accmdVariantIds = [];
    const excursionServices = findServiceOfType(state.tourServices, "excursion");
    const excursions = (excursionServices === null || excursionServices === void 0 ? void 0 : excursionServices.length) > 0 ? excursionServices.map(e => `${e.id}=${(e.currentVehicleTypeId == undefined ? '' : e.currentVehicleTypeId)}`).reduce((pr, curr) => `${pr};${curr}`) : "";
    const cart = JSON.parse(sessionStorage.getItem('frame-cart') || '{ "services": [] }');
    cart.services = [];
    const r = yield api('post', `/frame/${state.frameId}/tour-cart${state.tempFrameId ? `?tempId=${state.tempFrameId}` : ''}`, { accomodationIds: accmdVariantIds, tourVariantId: state.tourVariant.id, excursions: excursions, hash: state.hash, extras: mapExtrasToJsonCompatibility(state.extras) });
    if (r.errors)
        return r.errors;
    cart.services.push({ type: 'tour', tourVariantId: state.tourVariant.id, accmdVariantIds, excursions, cartData: r.response });
    cart.price = _.sum(_.map(cart.services, s => s.type == 'tour' ? s.cartData.priceInBookingCurrency : 0));
    cart.pricePerPerson = _.sum(_.map(cart.services, s => s.type == 'tour' ? (s.cartData.priceInBookingCurrency / (s.cartData.accommodation.adults + s.cartData.accommodation.childs)) : 0));
    cart.currency = r.response.bookingCurrency;
    sessionStorage.setItem('frame-cart', JSON.stringify(cart));
    return [];
});
const TourFrameDescriptionStoreActions = {
    loadDescription: loadDescription,
    loadExcursionPrices: loadExcursionPrices,
    setBookingParams: setBookingParams,
    setPriceItem: setPriceItem,
    setExcursionTransport: setExcursionTransport,
    loadAccommodationVariants: loadAccommodationVariants,
    loadHotelRecommendations: loadHotelRecommendations,
    book: tourFrameBook,
    enableLoading: () => ({ setState, getState }) => __awaiter(void 0, void 0, void 0, function* () {
        setState({ loading: true });
    }),
    disableLoading: () => ({ setState, getState }) => __awaiter(void 0, void 0, void 0, function* () {
        setState({ loading: false });
    }),
    enableFlightLoading: () => ({ setState, getState }) => __awaiter(void 0, void 0, void 0, function* () {
        setState({ flightsLoading: true });
    }),
    disableFlightLoading: () => ({ setState, getState }) => __awaiter(void 0, void 0, void 0, function* () {
        setState({ flightsLoading: false });
    }),
    setFlight: setFlight,
    loadExternalFlight: loadExternalFlight,
    setFlightVariants: setFlightVariants,
    addFlightVariants: addFlightVariants,
    clearFlightVariants: clearFlightVariants,
    searchExternalFlight: searchExternalFlight,
    resetStopsFilter: resetStopsFilter,
    resetAirlinesFilter: resetAirlinesFilter,
    resetBaggageFilter: resetBaggageFilter,
    resetStopDurationFilter: resetStopDurationFilter,
    resetTimeRangesFilter: resetTimeRangesFilter,
    resetAllSecondaryFilters: resetAllSecondaryFilters,
    setFlightFilter: setFlightFilter,
    reloadExtras: reloadExtras,
    updateExtra: updateExtra,
    getTourCost: getTourCost,
};
export const TourDescriptionStore = (isFrame = false) => isFrame ? TourDescriptionStoreFrame : TourDescriptionStoreDefault;
export const TourDescriptionStoreDefault = CreateTourDescriptionStore(TourDescriptionStoreActions);
export const TourDescriptionStoreFrame = CreateTourDescriptionStore(TourFrameDescriptionStoreActions);
export const useTourDescriptionStore = (isFrame = false) => isFrame ? useTourDescriptionStoreFrame() : useTourDescriptionStoreDefault();
export const useTourDescriptionStoreDefault = createHook(TourDescriptionStoreDefault);
export const useTourDescriptionStoreFrame = createHook(TourDescriptionStoreFrame);
export const useTourDescription = (arg, isFrame = false) => isFrame ? useTourDescriptionFrame() : useTourDescriptionDefault();
export const useTourDescriptionDefault = CreateTourDescriptionHook(TourDescriptionStoreDefault);
export const useTourDescriptionFrame = CreateTourDescriptionHook(TourDescriptionStoreFrame);
export const useTourFlightSearchMetadata = (arg, isFrame = false) => isFrame ? useTourFlightSearchMetadataFrame() : useTourFlightSearchMetadataDefault();
export const useTourFlightSearchMetadataDefault = CreateTourFlightSearchMetadataHook(TourDescriptionStoreDefault);
export const useTourFlightSearchMetadataFrame = CreateTourFlightSearchMetadataHook(TourDescriptionStoreFrame);
export const useViewConfig = (isFrame = false) => isFrame ? useViewConfigFrame() : useViewConfigDefault();
export const useViewConfigDefault = CreateViewConfigHook(TourDescriptionStoreDefault);
export const useViewConfigFrame = CreateViewConfigHook(TourDescriptionStoreFrame);
export const useTourExtras = (isFrame = false) => isFrame ? useTourExtrasFrame() : useTourExtrasDefault();
export const useTourExtrasDefault = CreateExtrasHook(TourDescriptionStoreDefault);
export const useTourExtrasFrame = CreateExtrasHook(TourDescriptionStoreFrame);
export const useTourVariant = (isFrame = false) => isFrame ? useTourVariantFrame() : useTourVariantDefault();
export const useTourVariantDefault = CreateTourVariantHook(TourDescriptionStoreDefault);
export const useTourVariantFrame = CreateTourVariantHook(TourDescriptionStoreFrame);
export const useTourAccmmdVariants = (isFrame = false) => isFrame ? useTourAccmmdVariantsFrame() : useTourAccmmdVariantsDefault();
export const useTourAccmmdVariantsDefault = CreateTourAccmmdVariantsHook(TourDescriptionStoreDefault);
export const useTourAccmmdVariantsFrame = CreateTourAccmmdVariantsHook(TourDescriptionStoreFrame);
export const useHotelRecommendations = (isFrame = false) => isFrame ? useHotelRecommendationsFrame() : useHotelRecommendationsDefault();
export const useHotelRecommendationsDefault = CreateHotelRecommendationsHook(TourDescriptionStoreDefault);
export const useHotelRecommendationsFrame = CreateHotelRecommendationsHook(TourDescriptionStoreFrame);
export const useFlightConfiguration = (isFrame = false) => createHook(isFrame ? TourDescriptionStoreFrame : TourDescriptionStoreDefault, {
    selector: createSelector(state => ({ flightConfiguration: state.flightConfiguration }), state => ({ flightConfiguration: state.flightConfiguration }))
})();
function findServiceOfType(array, type) {
    if (!(array === null || array === void 0 ? void 0 : array.length))
        return [];
    return array.filter(x => type == x.type);
}
